import {
  ArrayInput,
  AutocompleteInput,
  BooleanInput,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
  TextInput,
} from "react-admin";
import { Card, Grid, Typography } from "@mui/material";
import { settings } from "app";
import AcademicYearFilterInput from "server/components/Fields/AcademicYearFilterInput";
import { useFormContext, useWatch } from "react-hook-form";
import { useEffect, useState } from "react";
import dataProvider from "server/dataProvider";
import { SemestersChoices } from "utils/choices";
import { studentRequests } from "api/studentApi";

const CreateForm = ({ id, excludeIds }) => {
  const disciplineId = useWatch({ name: "disciplineId" });
  const { setValue, getValues } = useFormContext();
  const [semesters, setSemesters] = useState(null);
  const [modules, setModules] = useState(null);

  useEffect(() => {
    if (!disciplineId) {
      setSemesters(null);
      setModules(null);
      return;
    }
    const currentValues = getValues();
    Object.keys(currentValues).forEach(key => {
      if (key.startsWith("topics_semester_")) {
        setValue(key, undefined);
      }
    });
    setValue("moduleId", undefined);
    const fetchSemesters = async () => {
      try {
        const { data } = await dataProvider.customRequest(
          studentRequests.getCurriculumDisciplineSemesters(id, disciplineId),
          null,
          "GET",
        );
        setSemesters(data);
      } catch (err) {
        console.error(err);
      }
    };
    const fetchModules = async () => {
      try {
        const { data } = await dataProvider.customRequest(
          studentRequests.getCurriculumDisciplineModulesSelect(id, disciplineId),
          null,
          "GET",
        );
        setModules(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchSemesters();
    fetchModules();
  }, [disciplineId, id, setValue, getValues]);

  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="curriculumId"
            reference={studentRequests.getCurriculumsSelect()}
          >
            <SelectInput
              label="Учебен план"
              optionText="name"
              optionValue="id"
              readOnly={true}
              disabled={true}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <AcademicYearFilterInput />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="disciplineId"
            reference={studentRequests.getCurriculumDisciplinesSelect(id)}
            filter={{ filterByUser: true, ...(excludeIds?.length ? { excludeIds } : {}) }}
          >
            <AutocompleteInput
              filterToQuery={q => (q?.length > 2 ? { disciplineName: q } : {})}
              label="Дисциплина"
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
        {disciplineId && modules?.length > 0 && (
          <Grid
            item
            xs={12}
            md={6}
          >
            <SelectInput
              source="moduleId"
              label="Модул"
              choices={modules}
              optionText="name"
              optionValue="id"
              validate={required()}
              fullWidth
            />
          </Grid>
        )}
      </Grid>
      {disciplineId &&
        semesters &&
        semesters.map(semesterId => {
          const semesterName = SemestersChoices.find(c => c.id === semesterId)?.name || `Семестър ${semesterId}`;
          return (
            <Card
              key={semesterId}
              sx={{ px: 3, pt: 2, width: "100%", mb: 2 }}
            >
              <Typography
                color="primary"
                sx={{ mb: 1 }}
              >
                {semesterName}
              </Typography>
              <ArrayInput
                source={`topics_semester_${semesterId}`}
                label="Теми"
                defaultValue={[{}]}
              >
                <SimpleFormIterator sx={settings.style.iteratorWithoutGap}>
                  <Grid
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      xs={12}
                      md={5}
                    >
                      <TextInput
                        source="topicNameBg"
                        label="Име на български"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={5}
                    >
                      <TextInput
                        source="topicNameEn"
                        label="Име на английски"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={2}
                    >
                      <NumberInput
                        source="weekNumber"
                        label="Седмица номер"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={2}
                    >
                      <BooleanInput
                        source="isColloquium"
                        label="Колоквиум"
                      />
                    </Grid>
                  </Grid>
                </SimpleFormIterator>
              </ArrayInput>
            </Card>
          );
        })}
    </>
  );
};

export default CreateForm;
